

























































import Vue from 'vue';
import { PaymentMethods, PaymentsTable } from 'mycorems-app-billing';
import isGranted from '@/auth/isGranted';
import accountsGranted from '@/accounts/auth/isGranted';
import AgencySummaryTable from './AgencySummaryTable.vue';
import Clients from '../client/Clients.vue';
import AgencyUsers from './AgencyUsers.vue';
import AgencyLogo from './AgencyLogo.vue';
import AccountSettings from '../../account-settings/AccountSettings.vue';

export default Vue.extend({
  meta() {
    return {
      // @ts-ignore
      title: this.pageTitle,
    };
  },
  props: {
    agencyId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tab: '',
      tabLabel: {
        summary: 'Summary',
        clients: 'Account Info',
        users: 'Users',
        'api-key': 'Campaign Monitor API Key',
        'payment-methods': 'Payment Methods',
        billing: 'Billing',
        logo: 'Logo',
      },
    };
  },
  computed: {
    pageTitle(): string {
      return this.tabLabel[this.tab];
    },
  },
  methods: {
    getTabLabel(tab: string): string {
      return this.tabLabel[tab];
    },
    isGranted,
    accountsGranted,
  },
  created(): void {
    if (!isGranted('FIND_CLIENTS')) {
      this.tab = 'users';
    } else {
      this.tab = 'summary';
    }
  },
  components: {
    AgencySummaryTable,
    Clients,
    AgencyUsers,
    AccountSettings,
    PaymentMethods,
    PaymentsTable,
    AgencyLogo,
  },
});
